module.exports = __webpack_public_path__ + "img/1591482309.ece2f4a0.jpg";